import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const GetLocationById = {
  name: 'getLocationById',
  state: {
    data: {},
    loading: false,
    error: '',
  },
  reducers: {
    fetchRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    fetchSucceeded(state, payload) {
      return {
        ...state,
        data: payload,
        loading: false,
        error: '',
      };
    },

    fetchFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    },
    clearData(state) {
        return {
          ...state,
          data: {},
          error: '', 
        };
      },
  },
  effects: (dispatch) => ({
    async fetchLocationById(locationId) {
      try {
        this.fetchRequested();
        const response = await http.get(`savvy/locations/${locationId}`);
        this.fetchSucceeded(response.data);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Location fetched successfully!',
            show: true,
          },
        });
      } catch (error) {
        this.fetchFailed(error.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(error.message),
            show: true,
          },
        });
      }
    },
    clearFetchedData() {
        this.clearData();
      },
  }),
};

export default GetLocationById;
